import { ApolloCache, Reference, StoreObject } from '@apollo/client';

interface UpdateCacheProps {
  objectId: string;
  userId: string;
}

export const updateObjectResponsibleUsersCache = (cache: ApolloCache<any>, { objectId, userId }: UpdateCacheProps) => {
  cache.modify({
    id: `ObjectEntity:${objectId}`,
    fields: {
      responsibleUsers(prev = [], { readField }) {
        return prev.filter((el?: Reference | StoreObject) => readField('id', el) !== userId);
      },
    },
  });

  cache.modify({
    id: `User:${userId}`,
    fields: {
      responsibleObjects(prev = [], { readField }) {
        return prev.filter((el?: Reference | StoreObject) => readField('id', el) !== objectId);
      },
    },
  });
};
